
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.863","height":"22.291"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_42582","data-name":"Group 42582","transform":"translate(1.226 2.122)"}},[_c('g',{attrs:{"id":"Group_42583","data-name":"Group 42583","transform":"translate(.153 -.837)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_29640","data-name":"Path 29640","d":"M11.128 9.79V6.582a1.547 1.547 0 00-1.546-1.547H2.3A1.547 1.547 0 00.75 6.582v7.285a1.546 1.546 0 001.55 1.547h3.12","transform":"translate(-1.379 .535)"}}),_c('path',{attrs:{"id":"Path_29641","data-name":"Path 29641","d":"M9.776 10.473l-5.4 7.764h10.81z","transform":"translate(.19 2.019)"}}),_c('path',{attrs:{"id":"Path_29642","data-name":"Path 29642","d":"M11.821 11.131A5.24 5.24 0 106.1 3.7","transform":"translate(2.685 -1.285)"}})])])])
          )
        }
      }
    